function removeSpecialChar(string, noRemove) {
  const regex = `/[^0-9a-zA-Z${noRemove}]+/gi`;
  return string.replace(regex, '');
}

export default removeSpecialChar;
